// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2HJpV","row":"ProcedureTreatmentSummary_row__2t46k"};